<template>
  <v-list class="mx-auto" max-width="300" tile nav>
    <v-list-item-group v-model="active" color="var(--purple)">
      <v-list-item :key="link.tag" :to="{ name: link.name, params: { user: userId } }" exact v-for="link in primaryNav">
        <v-list-item-icon>
          <v-icon v-html="link.icon" class="mr-1"></v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="text-capitalize" v-html="link.tag"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>


<script>
import store from "@/store";
export default {
  name: "Navigation",
  components: {},
  data() {
    return {
      active: 1,
      primaryNav: [
        {
          tag: "Home",
          name: "dashboard",
          icon: "mdi-home-variant-outline",
        },
        {
          tag: "profile",
          name: "profile",
          icon: "mdi-account-circle",
        },
        { tag: "settings", name: "settings", icon: "mdi-cog-outline" },
        {
          tag: "about",
          name: "about",
          icon: "mdi-information-outline",
        },

        {
          tag: "invite others",
          name: "share",
          icon: "mdi-share-variant",
        },
        {
          tag: "feedback",
          name: "feedback",
          icon: "mdi-chat-outline",
        },
        {
          tag: "logout",
          name: "login",
          icon: "mdi-logout",
        },
      ],

    };
  },
  computed: {
    current_user: () => store.getters["auth/user"],
    userId() {
      const { user_id, username } = this.current_user;
      //if the username has not been set, use  truncated user_id as router params
      const current_user_id = username ? username : user_id;
      return current_user_id;
    },
  },
};
</script> 

<style scoped>
@media screen and (min-width: 600px) {

  .v-list-item-group *,
  .v-list-item-icon,
  .v-icon {
    color: var(--white) !important;
  }

  .v-divider {
    background: var(--white);
    opacity: 0.35;
  }
}
</style>